'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('../../../typography/ErrorText/ErrorText.js');
require('../../../typography/LargeDarkText/LargeDarkText.js');
require('../../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../../typography/MediumDarkText/MediumDarkText.js');
require('../../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../../typography/MediumText/MediumText.js');
require('../../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../../../typography/SmallDarkText/SmallDarkText.js');
require('../../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../../typography/SmallLinkText/SmallLinkText.js');
var SmallTitleText = require('../../../typography/SmallTitleText/SmallTitleText.js');
require('../../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../../typography/TinyDarkText/TinyDarkText.js');
require('../../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../../typography/TinyLinkText/TinyLinkText.js');
require('../../../typography/TinyTitleText/TinyTitleText.js');
require('../../../typography/XXLargeDarkText/XXLargeDarkText.js');
var MenuItem = _interopDefault(require('@material-ui/core/MenuItem'));
var styledComponents = require('../styled-components.js');

var StartMonthSelect = function (_a) {
    var months = _a.months, startMonth = _a.startMonth, handleStartMonthChange = _a.handleStartMonthChange, endYear = _a.endYear, endMonth = _a.endMonth, startYear = _a.startYear;
    return (React__default.createElement(styledComponents.StyledSelect, { "data-testid": 'start-month-select', value: startMonth, onChange: handleStartMonthChange, input: React__default.createElement(styledComponents.StyledInputRightPadding, null), inputProps: { 'data-testid': 'start-month-select-input' }, style: { width: '65px', height: '29px', fontSize: '14px' } }, months.map(function (month, i) { return (React__default.createElement(MenuItem, { key: month, value: "" + (i + 1), disabled: parseInt(startYear, 10) === parseInt(endYear, 10) && parseInt(endMonth, 10) < i + 1 },
        React__default.createElement(SmallTitleText, { style: { lineHeight: '29px' } }, month))); })));
};

module.exports = StartMonthSelect;
